/**
 * UUIDv7 generated on the device (system design §5: ids are born where the row is born and stay
 * time-ordered). 48-bit Unix milliseconds, then version/variant bits over random data. A
 * monotonic counter keeps ids ordered inside the same millisecond.
 */
let lastMs = 0;
let seq = 0;

export function uuidv7(): string {
  const now = Date.now();
  if (now === lastMs) seq = (seq + 1) & 0xfff;
  else {
    lastMs = now;
    seq = Math.floor(Math.random() * 0x1000);
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  const ms = BigInt(now);
  bytes[0] = Number((ms >> 40n) & 0xffn);
  bytes[1] = Number((ms >> 32n) & 0xffn);
  bytes[2] = Number((ms >> 24n) & 0xffn);
  bytes[3] = Number((ms >> 16n) & 0xffn);
  bytes[4] = Number((ms >> 8n) & 0xffn);
  bytes[5] = Number(ms & 0xffn);
  bytes[6] = 0x70 | ((seq >> 8) & 0x0f);
  bytes[7] = seq & 0xff;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
